export const UI_FLAG_CAROUSEL_MODAL = 'LOAD_DATA_FOR_MODAL_CAROUSEL';
export const UI_FLAG_CAROUSEL = 'LOAD_DATA_CAROUSEL';
export const EMPTY_OBJ = {};
